import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const RAMFooter = () => {
  const { t } = useTranslation("translation", { keyPrefix: "ramFooter" });
  const [siteLang, setSiteLang] = useState('en');
  useEffect(() => {
    if (document.documentElement.lang === 'en-US') {
      setSiteLang('en');
    } else if (document.documentElement.lang === 'fr-FR') {
      setSiteLang('fr');
    }
  }, [])
  const staticURL = {
    en: {
      search_tips: "/resources-around-me/search-tips/",
      faq: "/resources-around-me/faq/"
    },
    fr: {
      search_tips: "/ressources-autour-de-moi/astuces/",
      faq: " /ressources-autour-de-moi/faq/"
    }
  }
  return (
    <section className="app-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-xl-4 offset-xl-1">
            <div className="btn-wrapper">
              <a
                href={siteLang === 'en' ? staticURL.en.search_tips : staticURL.fr.search_tips}
                className="btn btn-white"
              >
                {t("search_tips")} <span className="sr-only">{t("new_tab")}</span>

              </a>

              <a href={siteLang === 'en' ? staticURL.en.faq : staticURL.fr.faq} className="btn btn-white">
                {t("ram_faq")}{" "}

                <span className="sr-only">{t("new_tab")}</span>
              </a>
            </div>
          </div>

          <div className="col-lg-6 offset-lg-1 col-xl-5 offset-xl-1">
            <div className="tell-us">
              <h4>{t("what_you_think")}</h4>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.surveymonkey.com/r/RAMFeedback"
                className="ext-link"
              >
                {t("user_experience")}
                <span className="sr-only">{t("new_tab")}</span>
              </a>
              <span className="ext-icon" aria-hidden="true"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default RAMFooter;
